










































import { recognition } from 'mycorems-app-accounts';
import { HasTaskMixin } from '@/mixins';
import eventBus from '@/messaging/event-bus';
import {
  ClientAdded, ClientEdited, PricePlanStarted, EmailReportGenerated,
} from '@/messaging/events';
import { Client, ClientFilters, QueryResult } from '@/types';
import repository from './client-repository';
import ClientUsage from '../../account-price-plan/ClientUsage.vue';

interface Data {
  clients: Client[],
  searchQuery: string|undefined,
}

export default HasTaskMixin.extend({
  model: {
    event: 'change',
  },
  props: {
    value: [String, Object],
    label: {
      type: String,
      default: 'Search by client name',
    },
    iconColor: {
      type: String,
      default: 'secondary',
    },
    isObject: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      clients: [],
      searchQuery: undefined,
    };
  },
  computed: {
    agencyId(): string|null {
      return recognition.getAccountId();
    },
    filters(): ClientFilters|null {
      if (!this.agencyId) return null;
      return {
        agencyId: this.agencyId,
        name: this.searchQuery,
      };
    },
  },
  methods: {
    change(value: Client|string): void {
      this.$emit('change', value);
      if (!value) return;
      let clientId = value;
      if (this.isObject) {
        clientId = (value as Client).id;
      }
      this.$router.push(`/accounts/${clientId}`);
    },
    filter(query, update) {
      this.searchQuery = query;
      update(() => {
        if (!query) return;
        this.load();
      });
    },
    onClientEdited(event: ClientEdited): void {
      const index = this.clients.findIndex(client => client.id === event.id);
      if (index >= 0) {
        this.clients[index].name = event.name;
      }
    },
    load(): void {
      if (!this.filters) return;
      this.task = repository.findAll(this.filters);
      this.task.then((result: QueryResult) => {
        this.clients = result.items as Client[];
      });
    },
  },
  created(): void {
    this.load();
    eventBus.$on(ClientAdded.eventName, this.load);
    eventBus.$on(ClientEdited.eventName, this.onClientEdited);
    eventBus.$on(PricePlanStarted.eventName, this.load);
    eventBus.$on(EmailReportGenerated.eventName, this.load);
  },
  beforeDestroy(): void {
    eventBus.$off(ClientAdded.eventName, this.load);
    eventBus.$off(ClientEdited.eventName, this.onClientEdited);
    eventBus.$off(PricePlanStarted.eventName, this.load);
    eventBus.$off(EmailReportGenerated.eventName, this.load);
  },
  components: {
    'client-usage': ClientUsage,
  },
});
